<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.mac_id" placeholder="设备物理地址"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getDevices">查询</el-button>
				</el-form-item>
				<!--<el-form-item>
					<el-button type="primary" @click="handleAdd">导出</el-button>
				</el-form-item>-->
			</el-form>
		</el-col>

		<!--列表-->
		<el-table @sort-change='sortion' :data="users" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<!--<el-table-column type="selection" width="50">
			</el-table-column>-->
			<el-table-column type="index" width="40">
			</el-table-column>
			<el-table-column prop="mac_id" label="设备物理地址" width="150" >
			</el-table-column>
			<el-table-column prop="city" label="城市" width="80" >
			</el-table-column>
			<el-table-column prop="address" label="地址" width="200" >
			</el-table-column>
			<el-table-column prop='running_time.running_time_one' label="运行时长">
			</el-table-column>
			<!--<el-table-column prop="lng" label="运行时长" width="" :formatter="formatSex" sortable>
			</el-table-column>-->
			<el-table-column prop="user_name" label="最后连接用户" width='130' >
			</el-table-column>
			<el-table-column prop="creat_time" label="首次连接时间" width='160' sortable='custom'>
			</el-table-column>
			<el-table-column prop="lastTime" label="最后连接时间" width='160'  sortable='custom'>
			</el-table-column>
			<el-table-column prop="upper_sysno" width='110' v-if='GLOBAL.organ_sysno==GLOBAL.adminSysno.adminOrgan' label="机构编号"  sortable>
			</el-table-column>
			<!--<el-table-column label="操作" width="100">
				<template slot-scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">查看详情</el-button>
				</template>
			</el-table-column>-->
			<!--<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>-->
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<!--<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除{{addFormVisible}}</el-button>-->
			<el-pagination layout="prev, pager, next,jumper"  @current-change="handleCurrentChange"  :page-size="size" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--编辑界面-->
		<!--<el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">-->
		<el-dialog title="编辑机构" :visible.sync="editFormVisible">
			<el-form :model="editForm" label-width="110px" ref="editForm">
				<el-form-item label="公司名称" prop="name" >
					<el-input v-model="editForm.name" prop="name"></el-input>
				</el-form-item>
				<el-form-item label="所属设备编号" >
					<el-input v-model="editForm.upper_sysno" prop="upper_sysno"></el-input>
				</el-form-item>
				<el-form-item label="账户号">
					<el-input v-model="editForm.account" prop="account"></el-input>
				</el-form-item>
				<el-form-item label="密码">
					<el-input v-model="editForm.password" prop="password"></el-input>
				</el-form-item>
				<!--<el-form-item label="地址">
					<el-input type="textarea" v-model="addForm.addr"></el-input>
				</el-form-item>-->
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
		<!--新增-->
		<el-dialog title="添加机构" :visible.sync="addFormVisible">
		  <el-form :model="addForm" label-width="110px" :rules="addFormRules" ref="addForm">
				<el-form-item label="公司名称" prop="name">
					<el-input v-model="addForm.name" ></el-input>
				</el-form-item>
				<el-form-item label="所属设备编号" >
					<el-input v-model="addForm.upper_sysno" prop="upper_sysno"></el-input>
				</el-form-item>
				<el-form-item label="账户号">
					<el-input v-model="addForm.account" prop="account"></el-input>
				</el-form-item>
				<el-form-item label="密码">
					<el-input v-model="addForm.password" ></el-input>
				</el-form-item>
				<!--<el-form-item label="地址">
					<el-input type="textarea" v-model="addForm.addr"></el-input>
				</el-form-item>-->
			</el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="addFormVisible = false">取 消</el-button>
		    <el-button type="primary" @click.native="addSubmit" :loading="addLoading">确 定</el-button>
		  </div>
		</el-dialog>
	</section>
</template>

<script>
	import util from '../common/js/util'
	//import NProgress from 'nprogress'
	import { getDeviceList, removeOrgan, batchRemoveUser, editUser} from '../api/api';

	export default {
		data() {
			return {
				filters: {
					mac_id: ''
				},
				users: [],
				total: 0,
				sort:'desc',
				prop:'lastTime',
				page: 1,
				size:10,
				listLoading: false,
				sels: [],//列表选中列
				//
				dialogFormVisible: false,
				form: {
			        name: '',
			        region: '',
			        date1: '',
			        date2: '',
			        delivery: false,
			        type: [],
			        resource: '',
			        desc: ''
		        },
        		formLabelWidth: '120px',
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					name: [
						{ required: true, message: '请输入公司名称', trigger: 'blur' }
					]
				},
				
			//编辑界面数据
				editForm: {
					name: '',
					sysno: '',
					upper_sysno: '',
					password: '',
					account: ''
				},
				addFormVisible: false,//新增界面是否显示
				addLoading: false,
				addFormRules: {
					name: [
						{ required: true, message: '请输入公司名称', trigger: 'blur' },
					],
				},
			//新增界面数据
				addForm: {
					name: '',
					upper_sysno:'',
					account: '',
					password: '',
				},
				runningTime:[],//设备列表运行时间

			}
		},
		methods: {
			//性别显示转换
			formatSex: function (row, column) {
				return row.sex == 1 ? '男' : row.sex == 0 ? '女' : '未知';
			},
			//排序
			sortion(row){
				this.prop=row.prop
				switch(row.order){
					case 'descending':
						this.sort='desc'
					break;
					case 'ascending':
						this.sort='asc'
					break;
				}
				this.getDevices()
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.page = val;
				this.getDevices();
			},
			//获取设备列表
			getDevices() {
				var that=this
				console.log(that.GLOBAL)
				let para = {
					mac_id:this.filters.mac_id.trim(),
					organ_sysno:that.GLOBAL.organ_sysno,
					prop:this.prop,
					sort:this.sort,
					pageNo:this.page,
					pageSize:this.size,
				};
				console.log(para)
				this.listLoading = true;
				//NProgress.start();
				getDeviceList(para).then((res) => {
					console.log(res)
					this.total = res.data.data.rowcount;
					this.users = res.data.data.list;
					this.listLoading = false;
					for(let i=0;i<res.data.data.list.length;i++){
						let updata_message=res.data.data.list[i].basic_massage
						if(!updata_message){
							continue;
						}
						let running_time={
							running_time_one:(parseInt(updata_message.slice(38, 40), 16)*256+parseInt(updata_message.slice(40, 42), 16))+'小时' + parseInt(updata_message.slice(42, 44), 16)+'分钟'+ parseInt(updata_message.slice(82, 84), 16)+'秒',//运行时间
						}
						that.users[i].running_time=running_time
						that.runningTime.push(running_time)
					}
					//NProgress.done();
				});
			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { sysno: row.sysno };
					removeOrgan(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.getDevices();
					});
				}).catch(() => {

				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editForm.sysno=row.sysno
				this.editForm.name=row.name
				this.editForm.account=row.account
				this.editForm.password=row.password
				this.editForm.upper_sysno=row.upper_sysno
//				this.editForm = Object.assign({}, row);
				console.log('editForm',this.editForm)
			},
			//显示新增界面
			handleAdd: function () {
				this.addFormVisible = true;
				this.addForm = {
					name: '',
					upper_sysno: '',
					account: '',
					password:'',
				};
			},
			//编辑
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认修改吗？', '提示', {}).then(() => {
							console.log(valid)
							this.editLoading = true;
							//NProgress.start();
							let para = Object.assign({}, this.editForm);
							//para.birth = (!para.birth || para.birth == '') ? '' : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
							editUser(para).then((res) => {
								this.editLoading = false;
								//NProgress.done();
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								this.$refs['editForm'].resetFields();
								this.editFormVisible = false;
								this.getDevices();
							});
						});
					}
				});
			},
			
			selsChange: function (sels) {
				this.sels = sels;
			},
			//批量删除
			batchRemove: function () {
				var ids = this.sels.map(item => item.id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { ids: ids };
					batchRemoveUser(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.getDevices();
					});
				}).catch(() => {

				});
			}
		},
		mounted() {
			this.getDevices();
		}
	}

</script>

<style lang="scss" slot-scope>

</style>


// WEBPACK FOOTER //
// src/components/device.vue